import type { ReactNode } from "react";
import type { DashboardSection } from "../routes";
import { sectionToPath } from "../routes";
import { Footer } from "../components/Footer";
import { Wordmark } from "../components/Wordmark";
import {
  BillingIcon,
  DashboardIcon,
  KeysIcon,
  ReceiptsIcon,
  SettingsIcon,
  TemplatesIcon,
  UsageIcon,
  WitnessLogIcon
} from "../components/SidebarIcons";

type NavItem = {
  section: DashboardSection;
  label: string;
  icon: ReactNode;
};

const NAV_ITEMS: NavItem[] = [
  { section: "dashboard", label: "Dashboard", icon: <DashboardIcon /> },
  { section: "usage", label: "Usage", icon: <UsageIcon /> },
  { section: "keys", label: "API Keys", icon: <KeysIcon /> },
  { section: "registrations", label: "Registered Identities", icon: <KeysIcon /> },
  { section: "templates", label: "Templates", icon: <TemplatesIcon /> },
  { section: "receipts", label: "Receipts", icon: <ReceiptsIcon /> },
  { section: "witness-log", label: "Witness Log", icon: <WitnessLogIcon /> },
  { section: "billing", label: "Billing", icon: <BillingIcon /> },
  { section: "settings", label: "Settings", icon: <SettingsIcon /> }
];

export function DashboardLayout(props: {
  email: string | null;
  activeSection: DashboardSection;
  onNavigate: (section: DashboardSection) => void;
  onSignOut: () => void;
  children: ReactNode;
}) {
  function signOut() {
    props.onSignOut();
  }
  return (
    <div className="app">
      <div className="header">
        <Wordmark />
        <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
          {props.email ? <span className="muted">{props.email}</span> : null}
          <button className="btn btn-secondary" onClick={signOut}>
            Sign out
          </button>
        </div>
      </div>
      <div className="layout">
        <aside className="sidebar">
          {NAV_ITEMS.map((item) => {
            const isActive = props.activeSection === item.section;
            return (
              <a
                key={item.section}
                href={sectionToPath(item.section)}
                className={isActive ? "active" : undefined}
                aria-current={isActive ? "page" : undefined}
                onClick={(e) => {
                  e.preventDefault();
                  props.onNavigate(item.section);
                }}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span>{item.label}</span>
              </a>
            );
          })}
        </aside>
        <main>{props.children}</main>
      </div>
      <Footer />
    </div>
  );
}
